import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import fibersIcon from './images/fibers-icon.svg';

const CheckFiberSuccess = (props) => {
    //console.info('iContent', props.iContent);

    let fiberData = {};
    var storage = window.localStorage || window.sessionStorage;
    try {
        fiberData = JSON.parse(storage.getItem('fiberData'));
    } catch (e) { }

    return (
        <div className='check-fiber-success'>
            <div className='fibers-top-bg'></div>
            <div className='page-headline-wrapper'>
                {
                    (props.iContent.title?.value) &&
                    <div className='page-title'> {props.iContent.title.value} </div>
                }
                <div className='page-sub-title'> בכתובת {fiberData?.form?.cityName}, רחוב {fiberData?.form?.streetName} {fiberData?.form?.home} </div>
                <div className='fibers-icon' style={{backgroundImage:fibersIcon.bg()}}></div>
                {
                    (props.iContent.productsTitle?.value) &&
                    <div className='package-text' dangerouslySetInnerHTML={{ __html: props.iContent.productsTitle?.value }}></div>
                }
                {
                    (!!props.iContent.isShowTechnicianTime?.value && fiberData?.technicianArrivalTime) &&
                    <div className='technician-text'> ויש גם טכנאי זמין ל-<sapn className='technician-time'>{fiberData?.technicianArrivalTime?.arrivalTime}</sapn> </div>
                }
            </div>

            <div className='PackagesItemsBlock__container'>
                <Container className='PackagesItemsBlock__container__items'>
                    <div className='PackagesItemsBlock__container__items__wraper'>
                        <ContentArea noWrap data={props.iContent.productsContentArea} context={props.context} />
                    </div>
                </Container>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(CheckFiberSuccess);
